import { useId, useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';

export default function LegendDisclosure() {
  const [open, setOpen] = useState(false);
  const contentId = useId();

  return (
    <div className="mt-2 pt-2 border-top border-light border-opacity-25">
      <button
        type="button"
        className="btn btn-link p-0 text-decoration-none text-light d-flex align-items-center gap-1"
        style={{ fontSize: 10 }}
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-controls={contentId}
      >
        <span aria-hidden="true" className="d-inline-flex align-items-center">
          {open ? <FaChevronDown size={10} /> : <FaChevronRight size={10} />}
        </span>
        <span>USGS / NWS info</span>
      </button>
      <Collapse in={open} mountOnEnter unmountOnExit>
        <div
          id={contentId}
          className="mt-2 small text-light d-flex flex-column gap-1 overflow-auto"
          style={{ maxHeight: '35vh' }}
        >
          <div>
            <span className="text-secondary">Comments:</span> The National Weather Service (NWS)
            uses selected USGS stream stations for river forecasts. These stations have flood stages
            assigned and maintained by the NWS. NWS river forecasts can be accessed{' '}
            <a
              href="https://water.noaa.gov/"
              target="_blank"
              rel="noreferrer"
              className="link-light text-decoration-underline"
            >
              here
            </a>
            .
          </div>
          <div>
            <span className="text-secondary">Source:</span>{' '}
            <a
              href="https://waterdata.usgs.gov/"
              target="_blank"
              rel="noreferrer"
              className="link-light text-decoration-underline"
            >
              USGS Water Data for the Nation
            </a>
          </div>
          <div>
            <span className="text-secondary">Service:</span>{' '}
            <a
              href="https://dashboard.waterdata.usgs.gov/service/cwis/1.0/odata/"
              target="_blank"
              rel="noreferrer"
              className="link-light text-decoration-underline"
            >
              USGS CWIS Services
            </a>{' '}
            (
            <a
              href="https://www.odata.org/"
              target="_blank"
              rel="noreferrer"
              className="link-light text-decoration-underline"
            >
              Open Data Protocol
            </a>
            )
          </div>
          <div>
            Click surface-water level stations to access a dashboard of recently collected data.
          </div>
        </div>
      </Collapse>
    </div>
  );
}
